module.exports = __webpack_public_path__ + "public/img/img_pt.afb559aa.png";